const Photos =()=>{
 return(
    <div>
        <h2>Photos</h2>
    </div>
 )
}
export default Photos;